import { Fragment, ReactElement, useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import StyledTableRow from "../../../components/styledTableRow";
import { IColumn, IConsumption } from "../../../types";
import TableContainer  from "../../../components/tableContainer";

const columns: IColumn[] = [
  {
    id: "materialGroup",
    label: "Material Group",
    minWidth: 200
  },
  {
    id: "material",
    label: "Material",
    minWidth: 200,
  },
  {
    id: "quantity",
    label: "Quantity",
    minWidth: 100,
    align: "right"
  },
  {
    id: "UOM",
    label: "UOM",
    minWidth: 100,
    align: "right",
  }
];

interface IProps {
  data: IConsumption[];
}

const ConsumptionPanel = ({ data }: IProps): ReactElement => {
  const [ consumption, setConsumption ] = useState<Record<string, IConsumption[]>>({});

  useEffect(() => {
    const result: Record<string, IConsumption[]> = {};

    data.forEach(d => {
      if(!result[d.materialGroup]) {
        result[d.materialGroup] = [ d ];
      } else {
        result[d.materialGroup].push(d);
      }
    });

    setConsumption(result);

  }, [data]);

  let total = 0;

  return (
    <div>
      <TableContainer>
        <Table stickyHeader={true} size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) =>
                <TableCell
                  className="table-header"
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, width: column.minWidth }}>
                  {column.label}
                </TableCell>
              )}
              <TableCell className="table-header"/>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(consumption).map((key) => {
              const items = consumption[key];
              let materialGroup = 0;

              return (
                <Fragment key={`consumption-${key}`}>
                  { items.map((row, indexRow) => {

                    materialGroup += row.quantity;
                    total += materialGroup;

                    return(
                      <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`consumption-row-${row.materialGroup}-${indexRow}`}>
                        {columns.map((column: IColumn) => {

                          const value = row[column.id as keyof IConsumption];

                          if (column.id === "materialGroup") {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {indexRow === 0 ? value : ""}
                              </TableCell>
                            );
                          }

                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.format && typeof value === "number" ? column.format(value) : value}
                            </TableCell>
                          );
                        })}
                        <TableCell/>
                      </StyledTableRow>
                    );
                  })}
                  <StyledTableRow hover={true} role="checkbox" tabIndex={-1} >
                    <TableCell><strong>{`${key} Total`}</strong></TableCell>
                    <TableCell/>
                    <TableCell align={"right"}><strong>{materialGroup.toFixed(2)}</strong></TableCell>
                    <TableCell/>
                    <TableCell/>
                  </StyledTableRow>
                </Fragment>
              );
            })}
            <StyledTableRow hover={true} role="checkbox" tabIndex={-1}  >
              <TableCell/>
              <TableCell><strong>Total</strong></TableCell>
              <TableCell align={"right"}><strong>{total.toFixed(2)}</strong></TableCell>
              <TableCell/>
              <TableCell/>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ConsumptionPanel;
